
export function request_state() {
    return {
        loading: false, succeed: null, error: {}, data: {},
    };
}

export function request_mutations(name, path) {
    return {
        [`${name}_loading`](state) {
            if (path !== undefined) state = state[path];
            state.loading = true;
            state.succeed = null;
            state.error = {};
        },
        [`${name}_success`](state, payload) {
            if (path !== undefined) state = state[path];
            state.loading = false;
            state.succeed = true;
            state.error = {};
            state.data = payload;
        },
        [`${name}_error`](state, payload) {
            if (path !== undefined) state = state[path];
            state.loading = false;
            state.succeed = false;
            state.error = payload;
        },
    };
}
